var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "12 10.07 572 748.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #333232;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.88313,315.16629,163.718,213.002A127.66715,127.66715,0,0,1,291.12035,85.43627c70.306,0,127.48451,57.17767,127.48451,127.40153L418.77,315.00033Zm349.74529-.166H493.14079L493.031,212.8378c-.083-111.30808-90.6293-201.85448-201.91062-201.77237C179.81148,11.14762,89.26508,101.69394,89.34806,213.002l.1643,102.16427h-7.305a69.30929,69.30929,0,0,0-69.20719,69.39912V688.72154a69.38058,69.38058,0,0,0,69.37228,69.317l431.42027-.24642a69.2048,69.2048,0,0,0,69.20711-69.31693V384.23689a69.31068,69.31068,0,0,0-69.37141-69.23656Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.5353,544.74622v73.077a11.55377,11.55377,0,0,1-11.54136,11.5416H281.04609a11.56353,11.56353,0,0,1-11.5836-11.5416v-73.077a49.403,49.403,0,1,1,57.07281,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.62243155ea36e8380c525ced92400b42.svg";
export { ForwardRef as ReactComponent };